import { InvestmentBudgetCard, InvestmentBudgetRollupRow } from './types';

const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();
  if (!res.ok || json.failure) throw new Error(json.em || json.message || 'Request failed');
  return json;
};

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const fetchInvestmentBudgetCards = async (filters: any): Promise<InvestmentBudgetCard> => {
  const json = await postBiz({ s: 'investmentbudget', a: 'cards', ...filters });
  return json.sd || json.result || json;
};

export const fetchInvestmentBudgetRows = async (filters: any) => {
  const json = await postBiz({ s: 'investmentbudget', a: 'find', ...filters, pgo: 0, pgl: 500 });
  return rows(json);
};

export const fetchInvestmentBudgetRollup = async (filters: any): Promise<InvestmentBudgetRollupRow[]> => {
  const json = await postBiz({ s: 'investmentbudget', a: 'rollup', ...filters });
  return rows(json);
};

export const saveInvestmentBudgetRows = async (filters: any, records: any[]) => {
  return postBiz({ s: 'investmentbudget', a: 'bulksave', ...filters, rcd: records });
};
